export const DEFAULT_CURSOR_CONTEXT_ID = "document";
